import checkout from "./form5";

const {
  formField5: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    supportData,
    enterVoiceover,
  },
} = checkout;

const initialValues5 = {
  [taxpayers.name]: "",
  [taxCode.name]: "",
  [taxAgentName.name]: "",
  [taxAgentCode.name]: "",

  [supportData.name]: false,
  [enterVoiceover.name]: false,
};

export default initialValues5;
